import React from 'react';
import { TFunction } from 'i18next';
import _get from 'lodash/get';
import { Asset } from 'graphql-common';
import TextCell from '@lib/components/Table/commonComponents/TextCell/TextCell';
import { CellProps } from '@lib/components/Table/types';
import { ChipTypes } from '@lib/components/Chip/Chip';
import ChipCell from '@lib/components/Table/commonComponents/ChipCell/ChipCell';
import CategoryCell from '@lib/components/Table/commonComponents/CategoryCell/CategoryCell';
import AssetPreviewCell from '@lib/components/Table/commonComponents/AssetPreviewCell/AssetPreviewCell';
import { APP_URLS } from 'constants/urls';

type ColumnsArgs = {
  t: TFunction<'translation', undefined>;
};

export default function getAssetsColumns({ t }: ColumnsArgs) {
  return [
    {
      id: 'code',
      Header: t('code'),
      accessor: 'code',
      Cell: (props: CellProps<Asset>) => <TextCell {...props} />,
      minWidth: 110,
      maxWidth: 110,
      width: 110,
      sortable: true,
    },
    {
      id: 'name',
      Header: t('name'),
      accessor: 'name',
      Cell: ({ item }: CellProps<Asset>) => (
        <AssetPreviewCell
          icon={
            item.iconAttached?.urls?.small ||
            item.iconAttached?.urls?.original ||
            item.iconAttached?.fileTag
          }
          name={item.name}
          url={APP_URLS.dashboard.assets.view.getDynamicPath({
            pathParts: {
              id: `${item.id}`,
            },
          })}
          target="_blank"
        />
      ),
      minWidth: 210,
      width: 310,
      sortable: true,
    },
    {
      id: 'categoryName',
      Header: t('category'),
      accessor: 'category',
      Cell: ({ item }: CellProps<Asset>) => (
        <CategoryCell
          label={item.category?.name}
          color={item.category?.color}
        />
      ),
      sortable: true,
      minWidth: 130,
      maxWidth: 250,
    },
    {
      id: 'siteCode',
      Header: t('site-code'),
      accessorFn: (props: CellProps<Asset>) =>
        _get(props, 'item.site.code', ''),
      Cell: (props: CellProps<Asset>) => <TextCell {...props} />,
      minWidth: 182,
      maxWidth: 182,
      width: 182,
    },
    {
      id: 'siteName',
      Header: t('site'),
      accessor: 'site',
      Cell: (props: CellProps<Asset>) => {
        const label = _get(props, 'item.site.name', '');
        if (!label) return '-';
        return <ChipCell label={label} type={ChipTypes.chipGray} />;
      },
      sortable: true,
      width: 200,
      maxWidth: 250,
    },
    {
      id: 'areaCode',
      Header: t('area-code'),
      Cell: (props: CellProps<Asset>) => {
        const label = _get(props, 'item.siteArea.code', '');
        if (!label) return '-';
        return <TextCell {...props} value={label} />;
      },
      minWidth: 110,
      maxWidth: 110,
      width: 110,
    },
    {
      id: 'siteAreaName',
      Header: t('area'),
      Cell: (props: CellProps<Asset>) => {
        const label = _get(props, 'item.siteArea.name', '');
        if (!label) return '-';
        return <ChipCell label={label} type={ChipTypes.chipGray} />;
      },
      sortable: true,
      maxWidth: 130,
      minWidth: 130,
    },
  ];
}
